import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import xbertReducer from './XBertSlice';

export const store = configureStore({
  reducer: {
    xbert: xbertReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
